import React from 'react';
import { Input, InputProps } from './Input';
import { Icon } from '../shared/Icon';

interface SearchInputProps extends InputProps {
    onSearch?: (value: string) => void;
}

export const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(({
    className = "",
    onSearch,
    ...props
}, ref) => {
    return (
        <div className={`relative ${className}`}>
            <div className="absolute left-3 top-1/2 -translate-y-1/2 text-wood-dark/60 dark:text-wood-light/60 pointer-events-none">
                <Icon name="search" className="text-xl" />
            </div>
            <Input
                ref={ref}
                className="pl-10 pr-4 py-2.5 bg-[#fff8e1] dark:bg-[#3e2723] focus:shadow-pixel-sm"
                {...props}
            />
        </div>
    );
});

SearchInput.displayName = "SearchInput";
